<template>
	<span class="d-inline-flex align-items-center gap-2">
		<span>{{ formatPhoneUS(phone.e164) }}</span>
		<a
			:href="`tel:${target}`"
			:aria-label="`Call ${formatPhoneUS(phone.e164)}`"
		>
			<i class="bi bi-telephone me-1"></i>Call
		</a>
		<a
			v-if="phone.can_sms"
			:href="`sms:${target}`"
			:aria-label="`Text ${formatPhoneUS(phone.e164)}`"
		>
			<i class="bi bi-chat-dots me-1"></i>Text
		</a>
	</span>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { formatPhoneUS, usPhoneDigits } from "@/format";
import type { Phone } from "@/type/api";

// One phone line: the number as the operator reads it, then a call action and,
// only where the number was reported as textable, a text action.
interface Props {
	phone: Phone;
}

const props = defineProps<Props>();

// The dial/text target. Stored numbers reach us in four shapes, one of them
// carrying parentheses and spaces, which must not be pasted into a tel: URI:
// a US number is rebuilt as E.164, anything else is stripped to digits and a
// leading plus.
const target = computed((): string => {
	const national = usPhoneDigits(props.phone.e164);
	return national === null
		? props.phone.e164.replace(/[^\d+]/g, "")
		: `+1${national}`;
});
</script>
